import styles from './styles/free-estimates.module.css';

const FreeEstimates = () => {
  
  return (
        <section className={styles.freeEstimateBanner}>
            <p>✅ We Offer <strong>Free Estimates</strong> – No Obligation!</p>
        </section>
    )
}
export default FreeEstimates